import React from "react";
import { Link } from "react-router-dom";
import "./Contact.css";
const ButtonMailto = ({ mailto, label }) => {
    return (
        <Link className='btn btn-outline-primary btn-lg btn-block pandora-submit'
            to='#'
            onClick={(e) => {
                window.location.href = mailto;
                e.preventDefault();
            }}
        >
            {label}
        </Link>
    );
};

export default ButtonMailto;
